export default __webpack_public_path__ + "static/media/aegean lee.46abbef6.jpg";